import { forwardRef, type ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

const TableCellButton = forwardRef<HTMLDivElement, ComponentProps<'div'>>(
	({ className, ...props }, ref) => (
		<div
			{...props}
			onClick={e => e.stopPropagation()}
			className={twMerge('w-fit max-w-full cursor-auto', className)}
			role="button"
			ref={ref}
			onKeyDown={e => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault(); // Prevent scrolling for spacebar
				}
			}}
			tabIndex={0}
		/>
	)
);

TableCellButton.displayName = 'TableCellButton';

export default TableCellButton;
